import React, { useEffect } from 'react';
import useCrmRoutes from '../../../../hooks/useCrmRoutes';
import { GET_CATEGORY_GROUPS_GQL } from '../graphql';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import Loader from '../../../../components/_organisms/Loader';
import CustomHeader from '../../../../components/_molecules/CustomHeader';

const Details: React.FC = () => {
  const { setCustomTitle, routes } = useCrmRoutes();
  const params = useParams<ParamTypes>();

  const { loading, data } = useQuery(GET_CATEGORY_GROUPS_GQL, {
    skip: !params?.id,
    variables: {
      id: params.id,
    },
  });

  useEffect(() => {
    if (data?.categoryGroup?.name) {
      setCustomTitle(data.categoryGroup.name);
    }
  }, [data, routes]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <CustomHeader
        title={`${data?.categoryGroup?.name || 'Details'}`}
        showList
      />
    </div>
  );
};

export default Details;
